import { UserAccessLevel, UserRoleType } from 'types/user';

export const USER_ROLE_TO_LEVEL_MAP: Record<UserRoleType, UserAccessLevel> = {
  [UserRoleType.SuperAdmin]: UserAccessLevel.SuperAdmin,
  [UserRoleType.Admin]: UserAccessLevel.Admin,
  [UserRoleType.Support]: UserAccessLevel.Support,
  [UserRoleType.Partner]: UserAccessLevel.Partner,
};
